module.exports = __webpack_public_path__ + "img/knsu_gallery2.7f9d30e4.jpg";